'use strict';

export default class Switch {
    constructor() {
        $('.switch__input').on('focus', function () {
            $(this).parent().addClass('focus');
        }).on('blur', function () {
            $(this).parent().removeClass('focus');
        }).on('change', function () {
            var $this = $(this),
                $parent = $this.parent();

            if ($this.is(':checked')) {
                $parent.addClass('checked');
            } else {
                $parent.removeClass('checked');
            }
        }).each(function () {
            var $this = $(this);

            if ($this.prop('checked')) {
                $this.parent().addClass('checked');
            }
        });


        $('#DoNotCalled').on('click', function(e){
            e.preventDefault();

            return false;
        });
    }
}
